module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_wrapper"
  }, [_c('div', {
    staticClass: "animate form login_form"
  }, [_c('section', {
    staticClass: "login_content"
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible fade in"
  }, [_vm._v("\n          " + _vm._s(_vm.message) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 1) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user),
      expression: "user"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.user)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.processCurrentStep()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 2) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.processCurrentStep()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.processCurrentStep()
      }
    }
  }, [_vm._v("Log in")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separator"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('h1', [_vm._v("EDEXIS")]), _vm._v(" "), _c('p', [_vm._v("©2016 All Rights Reserved. EDEXIS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00e45cc1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth/Phone.vue
// module id = 338
// module chunks = 1